<template>
    <v-dialog
            v-model="show"
            width="90vw"
            style=''
    >
        <v-card style='height:90vh;display:flex;flex-direction: column;overflow:hidden'>
            <v-card-title class="text-h5 pt-0">
                <button class="close-button" @click="show = false"><v-icon size="40px">close</v-icon></button>
                <br>
                <br>
            </v-card-title>
            <v-card-text style="height:100%;width:100%;padding:10px">
                <iframe :src="'data:application/pdf;base64,' + base64" width="100%" height="100%" style="border-radius: 10px;"></iframe>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

  export default {
    name: 'DialogPdf',
    props: {
      value: Boolean,
      base64: String
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    methods: {
    }
  }
</script>

<style scoped>
.close-button {
    position: absolute;
    top: 8px;
    right: 12px;
    outline: none;
}
</style>
